import './Layouts/Hero_Effect';

import NavBar from './Layouts/navbar';
const Header = () => {

  
    return ( 
        <div>
        {/* Hero Section */}
        <section className="hero" id="hero">
          {/* Gradient Background */}
          <div className="hero-grad" />
          {/* /Gradient Background */}
          {/* The SVG Diagonal Polygon (The important stuff)  */}
          <svg className="hero-diagonal" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="none">
            <polygon points="0,100 100,0 100,100" />
          </svg>
   
          <NavBar/>
          <main className="hero-content">
              
            <h1 className="heading">
              Here I am
            </h1>
            <br/>
            <div className="mouse center" />
            <p className="animation center"> Scrool
            </p></main>
          {/* /Demo Heading */}
        </section>
        
      </div>

     );
}
 
export default Header;